import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { SimpleApprovalButton } from '../../../components/Button/SimpleApprovalButton';
import type { Maybe, Relation } from '../../../types/api';
import type { RequestFriendCallback } from '../../api/relation';
import { useOnUpdateFriendStatus } from '../../api/relation';

interface Props {
  isPending: boolean;
  relation: Maybe<Relation>;
  authUserId: string;
  callback?: RequestFriendCallback;
  isFromFriendList?: boolean;
}

export const AcceptRefuseInvitation: FC<Props> = props => {
  const { isPending, relation, authUserId, callback, isFromFriendList = false } = props;
  const onAccept = useOnUpdateFriendStatus(relation, 'approved', callback);
  const onRemove = useOnUpdateFriendStatus(relation, 'refused', callback);
  if (!isPending || relation?.guest?.id !== authUserId) return null;

  return (
    <div
      className={twMerge(
        'AcceptRefuseInvitation flex gap-x-2',
        isFromFriendList ? 'flex-col gap-y-1' : 'ml-2 gap-x-2 text-xs justify-end',
      )}
    >
      <SimpleApprovalButton
        decision="deny"
        buttonType={isFromFriendList ? 'icon' : 'text'}
        onClick={onRemove}
        {...(isFromFriendList && { withTooltip: { placement: 'right' } })}
      />

      <SimpleApprovalButton
        decision="accept"
        buttonType={isFromFriendList ? 'icon' : 'text'}
        onClick={onAccept}
        {...(isFromFriendList && { withTooltip: { placement: 'right' } })}
      />
    </div>
  );
};
